<template>
  <LoadingSpinner v-if="isLoading" />
  <div id="main-wrapper" v-if="data">
    <NavbarDark />

    <!-- Show spinner if images are not loaded -->
    <div v-if="images.length <= 0">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <!-- Show BannerOne when images are loaded -->
    <BannerOne v-else :images="images" />

    <section class="gray-simple">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 col-md-12 col-sm-12">
            <div class="property_block_wrap style-2 p-4">
              <div class="prt-detail-title-desc">
                <!-- 1. Create a flex container to hold the label and button -->
                <div class="d-flex justify-content-between align-items-center">
                  <!-- Item 1: The tag2 label (For Rent / For Sell) -->
                  <span v-if="data.tag2 === 'For Rent'" class="label text-light bg-success">For Rent</span>
                  <span v-else-if="data.tag2 === 'For Sell'" class="label text-light bg-danger">For Sell</span>
                  <span v-else-if="data.tag2" class="label text-light bg-secondary">{{ data.tag2 }}</span>

                  <!-- Item 2: The "Edit Property" button -->
                  <div v-if="isAuthenticated">
                    <button @click="editProperty" class="btn btn-primary">
                      <i class="fa-solid fa-pen-to-square me-2"></i>Edit
                      Property
                    </button>
                  </div>
                </div>
                <h3 class="mt-3">{{ data.name }}</h3>
                <span
                  ><i class="fa-solid fa-location-dot"></i>
                  {{ data.loction }}</span
                >
                <h3 class="prt-price-fix text-primary mt-2">
                  $ {{ data.propertyValue }}
                </h3>
                <div class="list-fx-features">
                  <div class="listing-card-info-icon">
                    <div class="inc-fleat-icon me-1">
                      <img :src="bed" width="13" alt="" />
                    </div>
                    {{ data.beds }}
                  </div>
                  <div class="listing-card-info-icon">
                    <div class="inc-fleat-icon me-1">
                      <img :src="bathtub" width="13" alt="" />
                    </div>
                    {{ data.washrooms }} 
                  </div>
                  <div class="listing-card-info-icon">
                    <div class="inc-fleat-icon me-1">
                      <img :src="move" width="13" alt="" />
                    </div>
                    {{ data.sqft }} 
                  </div>
                  <div class="listing-card-info-icon availability-highlight">
                    <div
                      class="square--25 text-muted-2 fs-sm circle gray-simple me-1"
                    >
                      <i class="fa-solid fa-calendar-week fs-xs"></i>
                    </div>
                    <span class="text-primary fw-bold mx-2"
                      >Availability:
                    </span>
                    <span class="fw-semibold">{{ data.availableDate }}</span>
                  </div>
                </div>
              </div>
            </div>

            <PropertyDetail
              v-if="currentProperty"
              :currentProperty="currentProperty"
            />
          </div>

          <div class="col-lg-4 col-md-12 col-sm-12">
            <DetailSidebar v-if="currentProperty" :property="currentProperty" />
          </div>
        </div>
      </div>
    </section>

    <!-- <FooterTop :bg="'theme-bg'"/> -->
    <FooterDark />
    <ScrollToTop />
  </div>

  <!-- Show a loading indicator while data is being fetched -->
  <div v-else>
    <p>Loading property details...</p>
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import NavbarDark from "@/components/navbar/navbar-dark.vue";
import FooterDark from "@/components/footer/footer-dark.vue";
import ScrollToTop from "@/components/scroll-to-top.vue";
import PropertyDetail from "@/components/property/property-detail.vue";
import BannerOne from "@/components/banner-one.vue";
import bed from "@/assets/img/bed.svg";
import bathtub from "@/assets/img/bathtub.svg";
import move from "@/assets/img/move.svg";
import LoadingSpinner from "@/components/loading-spinner.vue"; // 1. Import the spinner
import DetailSidebar from "@/components/property/detail-sidebar.vue";
import { useRoute, useRouter } from "vue-router";

// 1. Import your auth store

const route = useRoute();
const store = useStore();
const propertyData = ref([]);
const data = ref({});
const images = ref([]);
let currentProperty = null;
const isLoading = ref(true);
const router = useRouter();
const isAuthenticated = computed(() => store.getters["auth/isAuthenticated"]);

onMounted(async () => {
  isLoading.value = true;
  console.log("isauthenticated:", isAuthenticated.value); // 2. Check authentication status
  // const authStore = useAuthStore();
  if (store.getters["properties/properties"].length === 0) {
    await store.dispatch("properties/loadPropertiesfirebaseAdmin");
  }
  propertyData.value = await store.getters["properties/properties"];
  data.value = await propertyData.value.find((item) => {
    return item.id === route.params.id;
  });
  console.log("Property Data: from singleproperty1.vue", data.value);
  console.log("calling setCurrentProperty with ID:", data.value.id);
  await store
    .dispatch("properties/setCurrentProperty", data.value.id)
    .then(async () => {
      currentProperty = await store.getters["properties/currentProperty"];
      console.log("Current Property:", currentProperty);
      images.value = currentProperty.ImageMap;
      console.log(images.value);
    })
    .catch((error) => {
      console.error("Error fetching property images:", error);
    })
    .finally(() => {
      isLoading.value = false; // 3. Set loading to false when done
    });
});

const editProperty = () => {
  if (data.value) {
    router.push({
      name: "submit-property",
      query: { id: data.value.id },
    });
  }
};
</script>
<style scoped>
.availability-highlight {
  background: #eaf4fb;
  border-radius: 8px;
  color: #009868;
}
</style>
